import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.map";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.function.bind";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { sanitizeFilename } from '../utils';
import uploadFile from '../utils/upload-file';

var FileUploader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FileUploader, _React$Component);

  function FileUploader(props) {
    var _this;

    _classCallCheck(this, FileUploader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileUploader).call(this, props));
    _this._handleOnChange = _this._handleOnChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._handleOnDrop = _this._handleOnDrop.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._handleOnDragEnter = _this._handleOnDragEnter.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(FileUploader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          signingUrl = _this$props.signingUrl,
          onInit = _this$props.onInit,
          onStart = _this$props.onStart,
          onProgress = _this$props.onProgress,
          onFinish = _this$props.onFinish,
          onError = _this$props.onError,
          onComplete = _this$props.onComplete,
          sanitize = _this$props.sanitize,
          enableDragDrop = _this$props.enableDragDrop,
          className = _this$props.className,
          onDragEnter = _this$props.onDragEnter,
          onDragLeave = _this$props.onDragLeave,
          children = _this$props.children,
          rest = _objectWithoutProperties(_this$props, ["signingUrl", "onInit", "onStart", "onProgress", "onFinish", "onError", "onComplete", "sanitize", "enableDragDrop", "className", "onDragEnter", "onDragLeave", "children"]);

      if (!enableDragDrop) {
        return React.createElement("input", _extends({}, rest, {
          onChange: this._handleOnChange,
          type: "file"
        }));
      } else {
        return React.createElement("div", {
          className: className,
          onDragOver: function onDragOver(e) {
            return e.preventDefault();
          },
          onDragEnter: this._handleOnDragEnter,
          onDragLeave: onDragLeave,
          onDrop: this._handleOnDrop
        }, children, React.createElement("input", _extends({}, rest, {
          onChange: this._handleOnChange,
          type: "file"
        })));
      }
    }
  }, {
    key: "_handleOnDragEnter",
    value: function _handleOnDragEnter(e) {
      (function (e) {
        return e.preventDefault();
      });

      var onDragEnter = this.props.onDragEnter;
      onDragEnter();
    }
  }, {
    key: "_handleOnChange",
    value: function () {
      var _handleOnChange2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(e) {
        var files;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                files = e.target.files;
                _context.next = 3;
                return this._uploadFiles(files);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function _handleOnChange(_x) {
        return _handleOnChange2.apply(this, arguments);
      };
    }()
  }, {
    key: "_handleOnDrop",
    value: function () {
      var _handleOnDrop2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(e) {
        var onDragLeave, files;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e.preventDefault();
                e.stopPropagation();
                onDragLeave = this.props.onDragLeave;
                onDragLeave();
                files = e.dataTransfer.files;
                _context2.next = 7;
                return this._uploadFiles(files);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function _handleOnDrop(_x2) {
        return _handleOnDrop2.apply(this, arguments);
      };
    }()
  }, {
    key: "_uploadFiles",
    value: function () {
      var _uploadFiles2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(files) {
        var _this2 = this;

        var _this$props2, onInit, onComplete, promises, uploadedFiles;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props2 = this.props, onInit = _this$props2.onInit, onComplete = _this$props2.onComplete;
                onInit ? onInit(files) : null;
                promises = _toConsumableArray(files).map(function (file) {
                  return _this2._uploadFile(file);
                });
                _context3.next = 5;
                return Promise.all(promises);

              case 5:
                uploadedFiles = _context3.sent;
                onComplete ? onComplete(uploadedFiles) : null;

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      return function _uploadFiles(_x3) {
        return _uploadFiles2.apply(this, arguments);
      };
    }()
  }, {
    key: "_uploadFile",
    value: function () {
      var _uploadFile2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(file) {
        var _this$props3, signingUrl, onStart, _onProgress, onFinish, onError, _sanitize, result, signingResult, uploadResult;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$props3 = this.props, signingUrl = _this$props3.signingUrl, onStart = _this$props3.onStart, _onProgress = _this$props3.onProgress, onFinish = _this$props3.onFinish, onError = _this$props3.onError, _sanitize = _this$props3.sanitize;
                onStart ? onStart(file) : null;
                result = null;
                signingResult = null;
                _context4.prev = 4;
                _context4.next = 7;
                return uploadFile(file, signingUrl, {
                  sanitize: function sanitize(name) {
                    return _sanitize ? _sanitize(name, sanitizeFilename) : sanitizeFilename(name);
                  },
                  onProgress: function onProgress(e) {
                    return _onProgress(file, e);
                  }
                });

              case 7:
                uploadResult = _context4.sent;
                result = uploadResult.result;
                signingResult = uploadResult.signingResult;
                _context4.next = 15;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](4);
                onError ? onError(file, _context4.t0) : null;

              case 15:
                onFinish ? onFinish(file, signingResult, result) : null;
                return _context4.abrupt("return", {
                  file: file,
                  signingResult: signingResult,
                  result: result
                });

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 12]]);
      }));

      return function _uploadFile(_x4) {
        return _uploadFile2.apply(this, arguments);
      };
    }()
  }]);

  return FileUploader;
}(React.Component);

_defineProperty(FileUploader, "propTypes", {
  /**
   * Select one or more files.
   */
  multiple: PropTypes.bool,

  /**
   * URL where the file will be uploaded.
   */
  signingUrl: PropTypes.string.isRequired,

  /**
   * Function called before the upload starts.
   */
  onInit: PropTypes.func,

  /**
   * Function called before the start of each file upload.
   */
  onStart: PropTypes.func,

  /**
   * Function called during the upload for each file.
   */
  onProgress: PropTypes.func,

  /**
   * Function called at the end of each file upload.
   */
  onFinish: PropTypes.func,

  /**
   * Function called called if an error is thrown during each file upload.
   */
  onError: PropTypes.func,

  /**
   * Function called once all files have been uploaded
   */
  onComplete: PropTypes.func,

  /**
   * Custom function to modify the file name before upload
   */
  sanitize: PropTypes.func,

  /**
   * Boolean that toggles between the drag-and-drop enabled version,
   * and the simpler, backwards compatible one.
   */
  enableDragDrop: PropTypes.bool,

  /**
   * Optional class name that can be passed to override the drop zone container's style
   */
  className: PropTypes.string,

  /**
   * Call back that is triggered on dragEnter
   */
  onDragEnter: PropTypes.func,

  /**
   * Callback that is triggered on dragLeave
   */
  onDragLeave: PropTypes.func
});

_defineProperty(FileUploader, "defaultProps", {
  multiple: false
});

export default FileUploader;